import { FilterCriteria } from '../types';

export const createFilterString = <Model>(filter: FilterCriteria<Model>) =>
    filter?.map(({ property, comparator, value }) => `${property.toString()}${comparator}${value}`).join(';');
